import React, { useState } from "react";
import { func } from "helpers";

const Store = React.createContext();

export const StoreProvider = ({ children }) => {
  const [fermeModal, setFermeModal] = React.useState(false);
  const [user, setUser] = React.useState(func.getStorageJson("user") || {});
  const [userProfile, setUserProfile] = useState({})
  const [campaigns, setCampaign] = React.useState(
    func.getStorageJson("campaigns") || []
  );
  const [operations, setOperations] = React.useState(
    func.getStorageJson("operations") || []
  );
  const [token, setToken] = React.useState(func.getStorage("token"));
  const [isAuth, setIsAuth] = React.useState(func.getStorage("isAuth"));
  const [tableData, setTableData] = React.useState([]);
  const [cahierData, setCahierData] = React.useState([]);
  const [tableDataResponse, setTableDataResponse] = React.useState({});
  const [activeFarm, setActiveFarm] = React.useState(func.getStorageJson("activeFarm") || {});
  const [activeCampaign, setActiveCampaign] = React.useState(func.getStorageJson("activeCampaign") || {});
  const [cahierTableDataResponse, setCahierTableDataResponse] = React.useState(
    {}
  );
  const [statistics, setStatistics] = React.useState([])
  const [entriesAndExitsOptionsList,setEntriesAndExitsOptionList]=useState([])
  const [paymentOption, setPaymentOption]=useState([])
  const [userDetails, setUserDetails]=useState({})
  const [farmList, setFarmList]= useState([])
  const [utils, SetUtils] = React.useState({
    directory: func.getStorageJson("directory") || [],
    loading: {
      primary: "",
      spinning: false,
      secondary: "",
    },
  });

  const state = {
    auth: { user, token, isAuth },
    utils,
    tableData,
    tableDataResponse,
    fermeModal,
    cahierData,
    cahierTableDataResponse,
    campaigns,
    operations,
    farmList,
    userDetails,
    activeFarm,
    activeCampaign,
    entriesAndExitsOptionsList,
    paymentOption,
    userProfile
  };

  const setAuth = (user, token) => {
    func.setStorageJson("user", user);
    func.setStorageJson("token", token);
    func.setStorageJson("isAuth", true);
    console.log(token);
    setUser(user);
    setToken(token);
    setIsAuth(true);
  };

  const setSelectedFarm = (farm) => {
    setActiveFarm(farm);
    func.setStorageJson("activeFarm", farm);
  };
  const setSelectedCampaignData = (campaign) => {
    setActiveCampaign(campaign);
    func.setStorageJson("activeCampaign", campaign);
  };

  const storeCampaign = (payload) => {
    const newCampaign = [...campaigns, payload];
    console.log(newCampaign);
    setCampaign(newCampaign);
    func.setStorageJson("campaigns", newCampaign);
  };

  const storeOperations = (payload) => {
    const newOperation = [...operations, payload];
    setOperations(newOperation);
    func.setStorageJson("operations", newOperation);
  };

  const setUtils = (key, value) => {
    func.setStorageJson(key, value);
    SetUtils((prevState) => ({ ...prevState, [key]: value }));
  };

  const logout = () => {
    setIsAuth(false);
    setUser({});
    setToken();
    setActiveCampaign(null);
    setActiveFarm(null);
    func.delStorage("user");
    func.delStorage("isAuth");
    func.delStorage("activeFarm");
    func.delStorage("activeCampaign");
    func.delStorage("token");
    func.delStorage('connected_conseiller')
    func.delStorage('admin_token')
  };

  return (
    <Store.Provider
      value={{
        state,
        setUser,
        setToken,
        setUtils,
        setAuth,
        logout,
        setTableData,
        setTableDataResponse,
        setFermeModal,
        setCahierData,
        setCahierTableDataResponse,
        storeCampaign,
        storeOperations,
        setFarmList,
        setUserDetails,
        setActiveFarm,
        setActiveCampaign,
        setSelectedCampaignData,
        setSelectedFarm,
        setEntriesAndExitsOptionList,
        setPaymentOption,
        setUserProfile,
        statistics,
        setStatistics
      }}
    >
      {children}
    </Store.Provider>
  );
};

export default Store;

export const useStore = () => React.useContext(Store);
